"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
exports.default = styled_components_1.default.p `
  color: ${config_1.colors.white};
  font: 600 24px ${config_1.fontFamilies.secondary};
  margin: 400px 0 10px;
`;
